import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueMask from 'v-mask';
import vueKanban from 'vue-kanban';
import wysiwyg from 'vue-wysiwyg';

import {
  CurrentUserMixin,
} from '@/mixins';
import './assets/scss/app.scss';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { auth } from './firebase';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueMask);
Vue.use(vueKanban);
Vue.use(wysiwyg, {
  hideModules: {
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    code: true,
    image: true,
    table: true,
    removeFormat: true,
    headings: true,
    italic: true,
    link: true,
    separator: true,
  },
  maxHeight: '300px',
});

Vue.mixin(CurrentUserMixin);

Vue.prototype.$log = console.log;

let app;

auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
      created() {
        store.watch(
          (state) => state.global.notifications,
          (notifications) => {
            const { content, title, variant } = notifications[notifications.length - 1];

            this.$bvToast.toast(content, {
              ...(title) ? { title } : {},
              variant,
              toaster: 'b-toaster-top-right',
            });
          },
        );
      },
    });
  }

  if (user) {
    store.dispatch('auth/fetchUserProfile', { user, app });
  } else {
    app.$mount('#app');
  }
});
